import React from 'react';
import Body from '../components/common/Body';

const HomeDashboard = () => {
  return (
    <div>
      <Body/>
    </div>
  )
}

export default HomeDashboard
 